import {IGetMemberCardUser} from "@interfaces";
import axiosClient from "./axiosClient";

export const cardAPI = {
  getMemberCardUser: (params: IGetMemberCardUser) => {
    const url = '/memberCardUser';
    return axiosClient.post(url, params);
  },
};
